export default __webpack_public_path__ + "static/media/evas-new-icon.3a907e4b.jpg";